// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function objectToFormData(obj: Record<string, any>): FormData {
	const formData = new FormData();

	for (const key in obj) {
		if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

		const value = obj[key];

		if (value instanceof File) {
			formData.append(key, value);
		} else if (Array.isArray(value)) {
			if (value.every((item) => item instanceof File)) {
				value.forEach((file) => formData.append(`${key}`, file));
			} else {
				formData.append(key, JSON.stringify(value));
			}
		} else if (typeof value === 'object' && value !== null) {
			formData.append(key, JSON.stringify(value));
		} else if (value !== undefined) {
			formData.append(key, String(value));
		}
	}

	return formData;
}

export function paramsToURICompatibleObject(
	params: Record<
		string,
		string | number | boolean | undefined | Array<string | number>
	>
): Record<string, string> {
	return Object.fromEntries(
		Object.entries(params).map(([key, value]) => {
			if (Array.isArray(value)) {
				return [key, JSON.stringify(value)];
			}
			if (value === undefined || value === null) {
				return [key, ''];
			}
			return [key, String(value)];
		})
	);
}

export function paramsToCacheKey(
	params: Record<
		string,
		string | number | boolean | undefined | Array<unknown> | null
	>
): string {
	return Object.entries(params ?? {})
		.sort(([keyA], [keyB]) => (keyA < keyB ? -1 : 1))
		.filter(([_key, value]) => value !== undefined)
		.map(([key, value]) => `${key}=${JSON.stringify(value)}`)
		.join('&');
}
